<!-- 积分明细- -->
<template>
    <div class="biDetail-module">
        <div class="list">
            <div v-for="(item, index) in list" :key="index">
                <div class="listitem">
                    <div class="menutit">
                        <div class="title">{{ item.scoreName }}</div>
                        <div class="title red" v-if="item.score >= 0">+{{ item.score }}</div>
                        <div class="title" v-if="item.score < 0">{{ item.score }}</div>
                    </div>
                    <div class="time">{{ item.createDate }}</div>
                </div>
            </div>
        </div>

        <div v-if="empty" style="margin:80px auto">
            <van-empty image="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-14/null.png" description="暂无数据" />
        </div>
    </div>
</template>

<script>
import request from "@/utils/request";
import { Toast } from 'vant'

export default {
    name: 'biDetailJoin',
    components: {},
    data() {
        return {
            list: [],
            empty: false
        }
    },
    mounted() {
        this.getList();
    },
    methods: {
        // 兑换列表
        getList() {
            request({
                url: `/my/myDetailJm`,
                method: "get",
            })
                .then((res) => {
                    this.list = res.data;
                    this.empty = res.data.length == 0 ? true : false
                }).catch(() => {
                    this.list = [];
                }).finally(() => {
                });
        }
    },
}
</script>

<style  scoped lang="less">
.biDetail-module {
    box-shadow: 0px 3px 0px 0px rgba(0, 0, 0, 0.02) inset;
    padding: 10px 0;
    height: 100%;
    overflow-y: auto;
}

.list {
    width: 100%;
    padding: 0px 30px 50px;
    box-sizing: border-box;
}

.listitem {
    width: 100%;
    height: 127px;
    border-bottom: 1px solid #f3f3f3;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.menutit {
    font-size: 26px;
    color: #35434c;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 70px;
}

.title {
    font-size: 30px;
}

.time {
    flex: 1;
    font-size: 24px;
    color: #a0acb5;
}

.red {
    color: #ee4c4c;
}
</style>